import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { getParameterByName } from "../../utils/helpers";
import "./search.css";
import axios from "axios";
import { host, frontendUrl } from "../../utils/globals";
import moment from "moment";

class Search extends Component {
  state = {
    data: "",
    meetingsPage: 1,
    mapInfoPage: 1,
    resourcesPage: 1
  };

  componentDidMount() {
    const query = getParameterByName("query", this.props.location.search);
    const url = `${host}/api/search?title=${query}&&limit=20`;

    axios
      .get(url)
      .then(res => this.setState({ data: res.data }))
      .catch(err => console.log(err));
  }

  handlePagenate = (btn, type, currntPage, totalPage) => e => {
    const { data } = this.state;

    const query = getParameterByName("query", this.props.location.search);

    currntPage =
      btn === "next"
        ? currntPage < totalPage
          ? currntPage + 1
          : currntPage
        : currntPage <= totalPage && currntPage > 1
        ? currntPage - 1
        : currntPage;

    const url = `${host}/api/search?title=${query}&&limit=20&&${type}=1&&page=${currntPage}`;

    axios
      .get(url)
      .then(res => {
        data[type].data = res.data.data;
        this.setState({ data, [`${type}Page`]: currntPage });
      })
      .catch(err => console.log(err));
  };

  componentDidUpdate = (prevProps, prevState) => {
    const query = getParameterByName("query", this.props.location.search);
    const oldQuery = getParameterByName("query", prevProps.location.search);

    const url = `${host}/api/search?title=${query}&&limit=20`;
    if (query !== oldQuery) {
      axios
        .get(url)
        .then(res => this.setState({ data: res.data }))
        .catch(err => console.log(err));
    }
  };
  render() {
    const query = getParameterByName("query", this.props.location.search);
    const { data } = this.state;

    let category = [
      {
        title: "Meeting Results",
        type: "meetings"
      },
      {
        title: "Maps/Infographics Results",
        type: "mapInfo"
      },
      {
        title: "News/Events Results",
        type: "newsEvents"
      },
      {
        title: "Resouces/Materials Results",
        type: "resources"
      }
    ];
    return (
      <div className="container">
        <div className="row">
          <div className="center">
            <h3>
              Result for <i>"{query}"</i>
            </h3>
          </div>

          {category &&
            category.map(d => (
              <div className="col-md-6 col-xs-12 col-lg-3" key={d.title}>
                <div className="title">
                  <i className="fa fa-caret-right" />
                  <b>{d.title}</b>
                  <span className="pull-right">
                    {data && data[d.type] && data[d.type].totalPage > 1 && (
                      <Fragment>
                        <i
                          className="fa fa-angle-double-left"
                          aria-hidden="true"
                          onClick={this.handlePagenate(
                            "prev",
                            d.type,
                            this.state[`${d.type}Page`],
                            data && data[d.type] && data[d.type].totalPage
                          )}
                        />
                        <span>{`${this.state[`${d.type}Page`]}/${data &&
                          data[d.type] &&
                          data[d.type].totalPage}`}</span>
                        <i
                          className="fa fa-angle-double-right"
                          aria-hidden="true"
                          onClick={this.handlePagenate(
                            "next",
                            d.type,
                            this.state[`${d.type}Page`],
                            data && data[d.type] && data[d.type].totalPage
                          )}
                        />
                      </Fragment>
                    )}
                  </span>
                </div>
                {data &&
                  data[d.type] &&
                  data[d.type].data.map((da, i) => (
                    <div className="searched-content" key={`item-${i}`}>
                      <div className="icon">
                        {
                          <i
                            className={
                              d.type === "meetings"
                                ? "fa fa-calendar"
                                : d.type === "newsEvents"
                                ? "fa fa-newspaper-o"
                                : "fa fa-map-o"
                            }
                          />
                        }
                      </div>
                      <div>
                        {d.type === "meetings" || d.type === "newsEvents" ? (
                          <Fragment>
                            <NavLink
                              to={`${
                                d.type === "meetings"
                                  ? "/recent-minutes"
                                  : "/news-events-detail"
                              }/${da.id}`}
                            >
                              {da.title}
                            </NavLink>

                            {d.type === "meetings" ? (
                              <Fragment>
                                <div className="venue text-muted">
                                  Venue :{da.venue}
                                </div>
                                <div className="start_time">
                                  Start :
                                  {moment(
                                    da.startAdDateTime &&
                                      da.startAdDateTime.date
                                  ).format("MMMM Do YYYY")}
                                </div>
                              </Fragment>
                            ) : (
                              <div>
                                <i className="fa fa-clock-o" />
                                <span>
                                  {moment(
                                    da.publishOn && da.publishOn.date
                                  ).format("MMMM Do YYYY")}
                                </span>
                              </div>
                            )}
                          </Fragment>
                        ) : (
                          <Fragment>
                            <a
                              href={`${frontendUrl + da.docFile}`}
                              target="_blank"
                            >
                              <p>{da.title}</p>
                            </a>
                            <i className="fa fa-clock-o" />
                            <span>
                              {moment(
                                da.publishedDate && da.publishedDate.date
                              ).format("MMMM Do YYYY")}
                            </span>
                          </Fragment>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    districtList: state.districtList,
    isEnglish: state.changeLanguage.isEnglish
  };
};

export default connect(mapStateToProps)(Search);
